import { render, staticRenderFns } from "./CustomDataForm.vue?vue&type=template&id=0014a81c"
import script from "./CustomDataForm.vue?vue&type=script&lang=js"
export * from "./CustomDataForm.vue?vue&type=script&lang=js"
import style0 from "./CustomDataForm.vue?vue&type=style&index=0&id=0014a81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports